import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token = useSelector((state) => state.userData.loginData.token);
  const accountType = useSelector(
    (state) => state.userData.loginData.account_type,
  );
  const location = useLocation();

  // Verifiers have a deliberately isolated workflow. Keep legacy authenticated
  // screens inaccessible even when a stale bookmark is opened directly.
  if (token && accountType === "VERIFIER" && location.pathname !== "/") {
    return <Navigate to="/" replace />;
  }

  return token ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
